import React from "react";
import { Button } from "antd";
import styled from "styled-components";
import {
  ID_TAB_TAKE_PRIZE,
  ID_TAB_EVENT_THINGYAN_2025,
} from "../../../../helper/const";
import PATH from "../../../../config/PATH";
import { useNavigate } from "react-router";
import icon from "../../../../assets/images/Event-2025/icon-btn.png";
import { useTranslation } from "react-i18next";

export default function Tab({ idActive = 1 }) {
  const navigate = useNavigate();
  const {t} = useTranslation()
  const data = [
    {
      id: ID_TAB_TAKE_PRIZE.takePrize,
      title: t("event_thingyan.home_page.take_prize"),
      url: `${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.takePrize}`,
    },
    {
      id: ID_TAB_TAKE_PRIZE.pieceCollection,
      title: t("event_thingyan.home_page.piece_collection"),
      url: `${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.pieceCollection}`,
    },
  ];

  const handleClickPage = (url) => {
    navigate(url);
  };

  return (
    <Container>
      {data.map((item) => {
        const isActive = idActive === item.id;
        return (
          <Button
            key={item.id}
            className={`btn-prize ${isActive ? "btn-active-prize" : ""}`}
            onClick={() => handleClickPage(item.url)}
          >
            {isActive ? (
              <img src={icon} alt="btn-icon-event" className="btn-icon-event" />
            ) : null}
            <div className="chilren-button"></div>
            <div className="content">{item.title}</div>
          </Button>
        );
      })}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 20px;

  .btn-icon-event {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -3px;
  }

  .btn-prize,
  .btn-prize:hover {
    background: linear-gradient(to bottom, #096ef5 0%, #6be1ff 100%) !important;
    height: 64px;
    border: 2px solid #6be1ff !important;
    width: 246px;
    border-radius: 40px;
    position: relative;
    color: white !important;
  }

  .chilren-button {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.34) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 40px;
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: bold;
  }

  .btn-active-prize,
  .btn-active-prize:hover {
    background: linear-gradient(to top, #fdfb9f 0%, #fcdb51 100%) !important;
    border: 2px solid white !important;

    .content {
      filter: drop-shadow(1px 0 0 #ffff) drop-shadow(-1px 0 0 #ffff)
        drop-shadow(0 1px 0 #ffff) drop-shadow(0 -1px 0 #ffff) !important;
      color: #fe9000 !important;
    }

    .chilren-button {
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.72) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  @media (min-width: 1400px) {
    gap: 32px;
    .btn-prize,
    .btn-prize:hover,
    .btn-active-prize:hover {
      width: 350px !important;
      height: 85px;
    }
    .content {
      font-size: 28px;
    }
    .chilren-button {
      width: calc(100% - 16px);
      height: calc(100% - 16px);
    }

    .btn-icon-event {
      width: 100%;
      left: 0;
      bottom: -3px;
    }
  }

  @media (min-width: 992px) {
    .btn-prize:hover {
      background: linear-gradient(
        to bottom,
        #1565ce 0%,
        #18cefc 100%
      ) !important;
      border: 2px solid #30c5eb !important;
      transition: 0.3s ease-in-out;
    }

    .btn-active-prize:hover {
      background: linear-gradient(to top, #fdfb9f 0%, #fcdb51 90%) !important;
      border: 2px solid white !important;

      .content {
        filter: drop-shadow(1px 0 0 #ffff) drop-shadow(-1px 0 0 #ffff)
          drop-shadow(0 1px 0 #ffff) drop-shadow(0 -1px 0 #ffff) !important;
        color: #fe9000 !important;
      }
    }
  }

  @media (max-width: 576px) {
    display: grid;
    grid-template-columns: 50% 50%;
    padding: 0 12px;

    .btn-prize,
    .btn-prize:hover {
      height: 54px;
      width: 100%;
    }

    .content {
      font-size: 16px;
    }
  }
`;
